<maced-global-navigation id="globalNavigationId" [menuToggleStateLabel]="menuToggleStateLabelEnglish" styleClass="testClass" [menuList]="menuList" 
[isOpened]="menuExpandCollapse" [currentRoute]="currentRoute" [showMoreMenuButton]="showMoreMenu" [showCollapseButton]="showCollapseButton"
[moreMenuLabel]="moreMenuLabel" >
</maced-global-navigation>